import queryString from 'query-string';

export function parseSearchParams(search) {
    return queryString.parse(search);
}

export function updateSearchParams(location, navigate, paramsToUpdate) {
    const params = {};


    Object.entries(paramsToUpdate).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            params[key] = Array.isArray(value) ? value.join(',') : value;
        }
    });

    const query = queryString.stringify(params);
    const newSearch = query ? `?${query}` : '';

    navigate(`${location.pathname}${newSearch}`, { replace: true });
}